(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire90c1"];
var parcelRegister = parcelRequire.register;
parcelRegister("7y9yw", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $57f31ef0d5c81b91$export$ae01dedf5c052bb; });
/*!
 * Splide.js
 * Version  : 0.8.0
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ function $57f31ef0d5c81b91$var$empty(array) {
    array.length = 0;
}
function $57f31ef0d5c81b91$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $57f31ef0d5c81b91$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($57f31ef0d5c81b91$var$slice$1(arguments, 1)));
}
function $57f31ef0d5c81b91$var$typeOf$1(type, subject) {
    return typeof subject === type;
}
var $57f31ef0d5c81b91$var$isArray$1 = Array.isArray;
$57f31ef0d5c81b91$var$apply$1($57f31ef0d5c81b91$var$typeOf$1, "function");
$57f31ef0d5c81b91$var$apply$1($57f31ef0d5c81b91$var$typeOf$1, "string");
$57f31ef0d5c81b91$var$apply$1($57f31ef0d5c81b91$var$typeOf$1, "undefined");
function $57f31ef0d5c81b91$var$toArray$1(value) {
    return $57f31ef0d5c81b91$var$isArray$1(value) ? value : [
        value
    ];
}
function $57f31ef0d5c81b91$var$forEach$1(values, iteratee) {
    $57f31ef0d5c81b91$var$toArray$1(values).forEach(iteratee);
}
function $57f31ef0d5c81b91$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
var $57f31ef0d5c81b91$var$ownKeys$1 = Object.keys;
function $57f31ef0d5c81b91$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $57f31ef0d5c81b91$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $57f31ef0d5c81b91$var$assign$1(object) {
    $57f31ef0d5c81b91$var$slice$1(arguments, 1).forEach(function(source) {
        $57f31ef0d5c81b91$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $57f31ef0d5c81b91$var$PROJECT_CODE$1 = "splide";
function $57f31ef0d5c81b91$var$EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $57f31ef0d5c81b91$var$forEach$1(targets, function(target) {
            target && $57f31ef0d5c81b91$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $57f31ef0d5c81b91$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $57f31ef0d5c81b91$var$EVENT_MOUNTED = "mounted";
var $57f31ef0d5c81b91$var$EVENT_MOVE = "move";
var $57f31ef0d5c81b91$var$EVENT_MOVED = "moved";
var $57f31ef0d5c81b91$var$EVENT_DRAG = "drag";
var $57f31ef0d5c81b91$var$EVENT_DRAGGING = "dragging";
var $57f31ef0d5c81b91$var$EVENT_SCROLL = "scroll";
var $57f31ef0d5c81b91$var$EVENT_SCROLLED = "scrolled";
var $57f31ef0d5c81b91$var$EVENT_DESTROY = "destroy";
function $57f31ef0d5c81b91$var$EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $57f31ef0d5c81b91$var$EventBinder();
    function on(events, callback) {
        binder.bind(bus, $57f31ef0d5c81b91$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $57f31ef0d5c81b91$var$isArray$1(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $57f31ef0d5c81b91$var$slice$1(arguments, 1));
    }
    if (Splide2) Splide2.event.on($57f31ef0d5c81b91$var$EVENT_DESTROY, binder.destroy);
    return $57f31ef0d5c81b91$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $57f31ef0d5c81b91$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
function $57f31ef0d5c81b91$var$State(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $57f31ef0d5c81b91$var$includes($57f31ef0d5c81b91$var$toArray$1(states), state);
    }
    return {
        set: set,
        is: is
    };
}
var $57f31ef0d5c81b91$var$CLASS_SLIDE = $57f31ef0d5c81b91$var$PROJECT_CODE$1 + "__slide";
var $57f31ef0d5c81b91$var$CLASS_CONTAINER = $57f31ef0d5c81b91$var$CLASS_SLIDE + "__container";
function $57f31ef0d5c81b91$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $57f31ef0d5c81b91$var$find(arrayLike, predicate) {
    return $57f31ef0d5c81b91$var$slice(arrayLike).filter(predicate)[0];
}
function $57f31ef0d5c81b91$var$apply(func) {
    return func.bind(null, ...$57f31ef0d5c81b91$var$slice(arguments, 1));
}
function $57f31ef0d5c81b91$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $57f31ef0d5c81b91$var$isObject(subject) {
    return !$57f31ef0d5c81b91$var$isNull(subject) && $57f31ef0d5c81b91$var$typeOf("object", subject);
}
const $57f31ef0d5c81b91$var$isArray = Array.isArray;
const $57f31ef0d5c81b91$var$isFunction = $57f31ef0d5c81b91$var$apply($57f31ef0d5c81b91$var$typeOf, "function");
const $57f31ef0d5c81b91$var$isString = $57f31ef0d5c81b91$var$apply($57f31ef0d5c81b91$var$typeOf, "string");
const $57f31ef0d5c81b91$var$isUndefined = $57f31ef0d5c81b91$var$apply($57f31ef0d5c81b91$var$typeOf, "undefined");
function $57f31ef0d5c81b91$var$isNull(subject) {
    return subject === null;
}
function $57f31ef0d5c81b91$var$isHTMLElement(subject) {
    return subject instanceof HTMLElement;
}
function $57f31ef0d5c81b91$var$toArray(value) {
    return $57f31ef0d5c81b91$var$isArray(value) ? value : [
        value
    ];
}
function $57f31ef0d5c81b91$var$forEach(values, iteratee) {
    $57f31ef0d5c81b91$var$toArray(values).forEach(iteratee);
}
function $57f31ef0d5c81b91$var$toggleClass(elm, classes, add) {
    if (elm) $57f31ef0d5c81b91$var$forEach(classes, (name)=>{
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $57f31ef0d5c81b91$var$addClass(elm, classes) {
    $57f31ef0d5c81b91$var$toggleClass(elm, $57f31ef0d5c81b91$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $57f31ef0d5c81b91$var$append(parent, children) {
    $57f31ef0d5c81b91$var$forEach(children, parent.appendChild.bind(parent));
}
function $57f31ef0d5c81b91$var$matches(elm, selector) {
    return $57f31ef0d5c81b91$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $57f31ef0d5c81b91$var$children(parent, selector) {
    const children2 = parent ? $57f31ef0d5c81b91$var$slice(parent.children) : [];
    return selector ? children2.filter((child)=>$57f31ef0d5c81b91$var$matches(child, selector)) : children2;
}
function $57f31ef0d5c81b91$var$child(parent, selector) {
    return selector ? $57f31ef0d5c81b91$var$children(parent, selector)[0] : parent.firstElementChild;
}
const $57f31ef0d5c81b91$var$ownKeys = Object.keys;
function $57f31ef0d5c81b91$var$forOwn(object, iteratee, right) {
    if (object) {
        let keys = $57f31ef0d5c81b91$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $57f31ef0d5c81b91$var$assign(object) {
    $57f31ef0d5c81b91$var$slice(arguments, 1).forEach((source)=>{
        $57f31ef0d5c81b91$var$forOwn(source, (value, key)=>{
            object[key] = source[key];
        });
    });
    return object;
}
function $57f31ef0d5c81b91$var$merge(object) {
    $57f31ef0d5c81b91$var$slice(arguments, 1).forEach((source)=>{
        $57f31ef0d5c81b91$var$forOwn(source, (value, key)=>{
            if ($57f31ef0d5c81b91$var$isArray(value)) object[key] = value.slice();
            else if ($57f31ef0d5c81b91$var$isObject(value)) object[key] = $57f31ef0d5c81b91$var$merge({}, $57f31ef0d5c81b91$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $57f31ef0d5c81b91$var$removeAttribute(elms, attrs) {
    $57f31ef0d5c81b91$var$forEach(elms, (elm)=>{
        $57f31ef0d5c81b91$var$forEach(attrs, (attr)=>{
            elm && elm.removeAttribute(attr);
        });
    });
}
function $57f31ef0d5c81b91$var$setAttribute(elms, attrs, value) {
    if ($57f31ef0d5c81b91$var$isObject(attrs)) $57f31ef0d5c81b91$var$forOwn(attrs, (value2, name)=>{
        $57f31ef0d5c81b91$var$setAttribute(elms, name, value2);
    });
    else $57f31ef0d5c81b91$var$forEach(elms, (elm)=>{
        $57f31ef0d5c81b91$var$isNull(value) || value === "" ? $57f31ef0d5c81b91$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $57f31ef0d5c81b91$var$create(tag, attrs, parent) {
    const elm = document.createElement(tag);
    if (attrs) $57f31ef0d5c81b91$var$isString(attrs) ? $57f31ef0d5c81b91$var$addClass(elm, attrs) : $57f31ef0d5c81b91$var$setAttribute(elm, attrs);
    parent && $57f31ef0d5c81b91$var$append(parent, elm);
    return elm;
}
function $57f31ef0d5c81b91$var$style(elm, prop, value) {
    if ($57f31ef0d5c81b91$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$57f31ef0d5c81b91$var$isNull(value)) elm.style[prop] = `${value}`;
}
function $57f31ef0d5c81b91$var$display(elm, display2) {
    $57f31ef0d5c81b91$var$style(elm, "display", display2);
}
function $57f31ef0d5c81b91$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $57f31ef0d5c81b91$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $57f31ef0d5c81b91$var$remove(nodes) {
    $57f31ef0d5c81b91$var$forEach(nodes, (node)=>{
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $57f31ef0d5c81b91$var$queryAll(parent, selector) {
    return selector ? $57f31ef0d5c81b91$var$slice(parent.querySelectorAll(selector)) : [];
}
function $57f31ef0d5c81b91$var$removeClass(elm, classes) {
    $57f31ef0d5c81b91$var$toggleClass(elm, classes, false);
}
const $57f31ef0d5c81b91$var$PROJECT_CODE = "splide";
function $57f31ef0d5c81b91$var$error(message) {
    console.error(`[${$57f31ef0d5c81b91$var$PROJECT_CODE}] ${message}`);
}
const { min: $57f31ef0d5c81b91$var$min, max: $57f31ef0d5c81b91$var$max, floor: $57f31ef0d5c81b91$var$floor, ceil: $57f31ef0d5c81b91$var$ceil, abs: $57f31ef0d5c81b91$var$abs } = Math;
function $57f31ef0d5c81b91$var$clamp(number, x, y) {
    const minimum = $57f31ef0d5c81b91$var$min(x, y);
    const maximum = $57f31ef0d5c81b91$var$max(x, y);
    return $57f31ef0d5c81b91$var$min($57f31ef0d5c81b91$var$max(minimum, number), maximum);
}
const $57f31ef0d5c81b91$var$CLASS_VIDEO = "splide__video";
const $57f31ef0d5c81b91$var$CLASS_VIDEO_WRAPPER = `${$57f31ef0d5c81b91$var$CLASS_VIDEO}__wrapper`;
const $57f31ef0d5c81b91$var$CLASS_VIDEO_PLAY_BUTTON = `${$57f31ef0d5c81b91$var$CLASS_VIDEO}__play`;
const $57f31ef0d5c81b91$var$CLASS_PLAYING = "is-playing";
const $57f31ef0d5c81b91$var$CLASS_ERROR = "is-error";
const $57f31ef0d5c81b91$var$CLASS_VIDEO_DISABLED = "is-video-disabled";
const $57f31ef0d5c81b91$var$MODIFIER_HAS_VIDEO = "--has-video";
const $57f31ef0d5c81b91$var$YOUTUBE_DATA_ATTRIBUTE = "data-splide-youtube";
const $57f31ef0d5c81b91$var$VIMEO_DATA_ATTRIBUTE = "data-splide-vimeo";
const $57f31ef0d5c81b91$var$HTML_VIDEO__DATA_ATTRIBUTE = "data-splide-html-video";
const $57f31ef0d5c81b91$var$DEFAULTS = {
    hideControls: false,
    loop: false,
    mute: false,
    volume: 0.2
};
const $57f31ef0d5c81b91$var$EVENT_VIDEO_PLAY = "video:play";
const $57f31ef0d5c81b91$var$EVENT_VIDEO_PAUSE = "video:pause";
const $57f31ef0d5c81b91$var$EVENT_VIDEO_ENDED = "video:ended";
const $57f31ef0d5c81b91$var$EVENT_VIDEO_ERROR = "video:error";
const $57f31ef0d5c81b91$var$EVENT_VIDEO_CLICK = "video:click";
const $57f31ef0d5c81b91$var$NOT_INITIALIZED = 1;
const $57f31ef0d5c81b91$var$INITIALIZING = 2;
const $57f31ef0d5c81b91$var$INITIALIZED = 3;
const $57f31ef0d5c81b91$var$PENDING_PLAY = 4;
const $57f31ef0d5c81b91$var$IDLE = 5;
const $57f31ef0d5c81b91$var$LOADING = 6;
const $57f31ef0d5c81b91$var$PLAY_REQUEST_ABORTED = 7;
const $57f31ef0d5c81b91$var$PLAYING = 8;
const $57f31ef0d5c81b91$var$ERROR = 9;
class $57f31ef0d5c81b91$var$AbstractVideoPlayer {
    constructor(target, videoId, options){
        this.state = $57f31ef0d5c81b91$var$State($57f31ef0d5c81b91$var$NOT_INITIALIZED);
        this.event = $57f31ef0d5c81b91$var$EventInterface();
        this.target = target;
        this.videoId = videoId;
        this.options = options || {};
        this.onPlay = this.onPlay.bind(this);
        this.onPause = this.onPause.bind(this);
        this.onEnded = this.onEnded.bind(this);
        this.onPlayerReady = this.onPlayerReady.bind(this);
        this.onError = this.onError.bind(this);
    }
    on(events, callback) {
        this.event.on(events, callback);
    }
    play() {
        const { state: state } = this;
        if (state.is($57f31ef0d5c81b91$var$ERROR)) {
            $57f31ef0d5c81b91$var$error("Can not play this video.");
            return;
        }
        this.event.emit("play");
        if (state.is($57f31ef0d5c81b91$var$INITIALIZING)) return state.set($57f31ef0d5c81b91$var$PENDING_PLAY);
        if (state.is($57f31ef0d5c81b91$var$INITIALIZED)) {
            this.player = this.createPlayer(this.videoId);
            return state.set($57f31ef0d5c81b91$var$PENDING_PLAY);
        }
        if (state.is([
            $57f31ef0d5c81b91$var$PENDING_PLAY,
            $57f31ef0d5c81b91$var$PLAYING
        ])) return;
        if (state.is($57f31ef0d5c81b91$var$IDLE)) {
            state.set($57f31ef0d5c81b91$var$LOADING);
            this.playVideo();
        }
    }
    pause() {
        const { state: state } = this;
        if (state.is($57f31ef0d5c81b91$var$ERROR)) return;
        this.event.emit("pause");
        if (state.is($57f31ef0d5c81b91$var$PENDING_PLAY)) return state.set($57f31ef0d5c81b91$var$INITIALIZING);
        if (state.is($57f31ef0d5c81b91$var$LOADING)) return state.set($57f31ef0d5c81b91$var$PLAY_REQUEST_ABORTED);
        if (state.is($57f31ef0d5c81b91$var$PLAYING)) {
            this.pauseVideo();
            this.state.set($57f31ef0d5c81b91$var$IDLE);
        }
    }
    isPaused() {
        return !this.state.is($57f31ef0d5c81b91$var$PLAYING);
    }
    destroy() {
        this.event.destroy();
    }
    onPlayerReady() {
        const { state: state } = this;
        const isPending = state.is($57f31ef0d5c81b91$var$PENDING_PLAY);
        state.set($57f31ef0d5c81b91$var$IDLE);
        if (isPending) this.play();
    }
    onPlay() {
        const { state: state } = this;
        const aborted = state.is($57f31ef0d5c81b91$var$PLAY_REQUEST_ABORTED);
        state.set($57f31ef0d5c81b91$var$PLAYING);
        if (aborted) this.pause();
        else this.event.emit("played");
    }
    onPause() {
        this.state.set($57f31ef0d5c81b91$var$IDLE);
        this.event.emit("paused");
    }
    onEnded() {
        this.state.set($57f31ef0d5c81b91$var$IDLE);
        this.event.emit("ended");
    }
    onError() {
        this.state.set($57f31ef0d5c81b91$var$ERROR);
        this.event.emit("error");
    }
}
class $57f31ef0d5c81b91$var$HTMLVideoPlayer extends $57f31ef0d5c81b91$var$AbstractVideoPlayer {
    constructor(target, videoId, options = {}){
        super(target, videoId, options);
        this.state.set($57f31ef0d5c81b91$var$INITIALIZED);
    }
    createPlayer(videoId) {
        const { options: options, options: { playerOptions: playerOptions = {} } } = this;
        const player = $57f31ef0d5c81b91$var$create("video", {
            src: videoId
        }, this.target);
        const on = player.addEventListener.bind(player);
        $57f31ef0d5c81b91$var$assign(player, {
            controls: !options.hideControls,
            loop: options.loop,
            volume: $57f31ef0d5c81b91$var$clamp(options.volume, 0, 1),
            muted: options.mute
        }, playerOptions.htmlVideo || {});
        on("play", this.onPlay);
        on("pause", this.onPause);
        on("ended", this.onEnded);
        on("loadeddata", this.onPlayerReady);
        on("error", this.onError);
        return player;
    }
    playVideo() {
        const promise = this.player.play();
        promise && promise.catch(this.onError.bind(this));
    }
    pauseVideo() {
        this.player.pause();
    }
    onError() {
        if (this.state.is($57f31ef0d5c81b91$var$PLAY_REQUEST_ABORTED)) this.state.set($57f31ef0d5c81b91$var$IDLE);
        else super.onError();
    }
    destroy() {
        super.destroy();
        const { player: player } = this;
        const off = player.addEventListener.bind(player);
        off("play", this.onPlay);
        off("pause", this.onPause);
        off("ended", this.onEnded);
        off("loadeddata", this.onPlayerReady);
    }
}
/*! @vimeo/player v2.17.1 | (c) 2022 Vimeo | MIT License | https://github.com/vimeo/player.js */ function $57f31ef0d5c81b91$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $57f31ef0d5c81b91$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $57f31ef0d5c81b91$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $57f31ef0d5c81b91$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $57f31ef0d5c81b91$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * @module lib/functions
 */ /**
 * Check to see this is a node environment.
 * @type {Boolean}
 */ /* global global */ var $57f31ef0d5c81b91$var$isNode = typeof $parcel$global !== "undefined" && ({}).toString.call($parcel$global) === "[object global]";
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $57f31ef0d5c81b91$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $57f31ef0d5c81b91$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && "nodeName" in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $57f31ef0d5c81b91$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $57f31ef0d5c81b91$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $57f31ef0d5c81b91$var$isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
    return expr.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $57f31ef0d5c81b91$var$getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
    if ($57f31ef0d5c81b91$var$isInteger(idOrUrl)) return "https://vimeo.com/".concat(idOrUrl);
    if ($57f31ef0d5c81b91$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace("http:", "https:");
    if (id) throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}
var $57f31ef0d5c81b91$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== "undefined";
var $57f31ef0d5c81b91$var$postMessageSupport = typeof window !== "undefined" && typeof window.postMessage !== "undefined";
if (!$57f31ef0d5c81b91$var$isNode && (!$57f31ef0d5c81b91$var$arrayIndexOfSupport || !$57f31ef0d5c81b91$var$postMessageSupport)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var $57f31ef0d5c81b91$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $57f31ef0d5c81b91$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, "x", {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, "_id", genId("_WeakMap")); // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError("WeakMap iterable is not supported");
        } // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, "delete", function(key) {
            checkInstance(this, "delete");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        }); // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, "get", function(key) {
            checkInstance(this, "get");
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        }); // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, "has", function(key) {
            checkInstance(this, "has");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        }); // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, "set", function(key, value) {
            checkInstance(this, "set");
            if (!isObject(key)) throw new TypeError("Invalid value used as weak map key");
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, "_id")) throw new TypeError(methodName + " method called on incompatible receiver " + typeof x);
        }
        function genId(prefix) {
            return prefix + "_" + rand() + "." + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, "_polyfill", true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $57f31ef0d5c81b91$var$commonjsGlobal !== "undefined" ? $57f31ef0d5c81b91$var$commonjsGlobal : $57f31ef0d5c81b91$var$commonjsGlobal);
var $57f31ef0d5c81b91$var$npo_src = $57f31ef0d5c81b91$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $57f31ef0d5c81b91$var$commonjsGlobal != "undefined" ? $57f31ef0d5c81b91$var$commonjsGlobal : $57f31ef0d5c81b91$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout; // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        } // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        } // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        } // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this; // already triggered?
            if (self1.triggered) return;
            self1.triggered = true; // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this; // already triggered?
            if (self1.triggered) return;
            self1.triggered = true; // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
             // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                }; // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false); // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype; // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this; // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this; // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this; // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ var $57f31ef0d5c81b91$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$storeCallback(player, name, callback) {
    var playerCallbacks = $57f31ef0d5c81b91$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $57f31ef0d5c81b91$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $57f31ef0d5c81b91$var$getCallbacks(player, name) {
    var playerCallbacks = $57f31ef0d5c81b91$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $57f31ef0d5c81b91$var$removeCallback(player, name, callback) {
    var playerCallbacks = $57f31ef0d5c81b91$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
     // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $57f31ef0d5c81b91$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $57f31ef0d5c81b91$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $57f31ef0d5c81b91$var$shiftCallbacks(player, name) {
    var playerCallbacks = $57f31ef0d5c81b91$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    var callback = playerCallbacks.shift();
    $57f31ef0d5c81b91$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$swapCallbacks(oldElement, newElement) {
    var playerCallbacks = $57f31ef0d5c81b91$var$callbackMap.get(oldElement);
    $57f31ef0d5c81b91$var$callbackMap.set(newElement, playerCallbacks);
    $57f31ef0d5c81b91$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $57f31ef0d5c81b91$var$parseMessageData(data) {
    if (typeof data === "string") try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    var message = {
        method: method
    };
    if (params !== undefined) message.value = params;
     // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$processData(player, data) {
    data = $57f31ef0d5c81b91$var$parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
        if (data.event === "error") {
            var promises = $57f31ef0d5c81b91$var$getCallbacks(player, data.data.method);
            promises.forEach(function(promise) {
                var error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $57f31ef0d5c81b91$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $57f31ef0d5c81b91$var$getCallbacks(player, "event:".concat(data.event));
        param = data.data;
    } else if (data.method) {
        var callback = $57f31ef0d5c81b91$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach(function(callback) {
        try {
            if (typeof callback === "function") {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {}
    });
}
/**
 * @module lib/embed
 */ var $57f31ef0d5c81b91$var$oEmbedParameters = [
    "autopause",
    "autoplay",
    "background",
    "byline",
    "color",
    "controls",
    "dnt",
    "height",
    "id",
    "interactive_params",
    "keyboard",
    "loop",
    "maxheight",
    "maxwidth",
    "muted",
    "playsinline",
    "portrait",
    "responsive",
    "speed",
    "texttrack",
    "title",
    "transparent",
    "url",
    "width"
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $57f31ef0d5c81b91$var$getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $57f31ef0d5c81b91$var$oEmbedParameters.reduce(function(params, param) {
        var value = element.getAttribute("data-vimeo-".concat(param));
        if (value || value === "") params[param] = value === "" ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $57f31ef0d5c81b91$var$createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) throw new TypeError("An element must be provided");
    if (element.getAttribute("data-vimeo-initialized") !== null) return element.querySelector("iframe");
    var div = document.createElement("div");
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute("data-vimeo-initialized", "true");
    return element.querySelector("iframe");
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $57f31ef0d5c81b91$var$getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function(resolve, reject) {
        if (!$57f31ef0d5c81b91$var$isVimeoUrl(videoUrl)) throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
        var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
        for(var param in params)if (params.hasOwnProperty(param)) url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        var xhr = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                return;
            }
            try {
                var json = JSON.parse(xhr.responseText); // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $57f31ef0d5c81b91$var$createEmbed(json, element);
                    reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            var status = xhr.status ? " (".concat(xhr.status, ")") : "";
            reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"));
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error creating an embed: ".concat(error));
    };
    elements.forEach(function(element) {
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute("data-vimeo-defer") !== null) return;
            var params = $57f31ef0d5c81b91$var$getOEmbedParameters(element);
            var url = $57f31ef0d5c81b91$var$getVimeoUrl(params);
            $57f31ef0d5c81b91$var$getOEmbedData(url, params, element).then(function(data) {
                return $57f31ef0d5c81b91$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
        if (!$57f31ef0d5c81b91$var$isVimeoUrl(event.origin)) return;
         // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== "spacechange") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            if (iframes[i].contentWindow !== event.source) continue;
             // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            var space = iframes[i].parentElement;
            space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
            break;
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $57f31ef0d5c81b91$var$initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
        if (!$57f31ef0d5c81b91$var$isVimeoUrl(event.origin)) return;
        var data = $57f31ef0d5c81b91$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            var iframe = iframes[i]; // Initiate appendVideoMetadata if iframe is a Vimeo embed
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($57f31ef0d5c81b91$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $57f31ef0d5c81b91$var$Player$1(iframe);
                player.callMethod("appendVideoMetadata", window.location.href);
            }
        }
    };
    window.addEventListener("message", onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $57f31ef0d5c81b91$var$initializeScreenfull() {
    var fn = function() {
        var val;
        var fnMap = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
        request: function request(element) {
            return new Promise(function(resolve, reject) {
                var onFullScreenEntered = function onFullScreenEntered() {
                    screenfull.off("fullscreenchange", onFullScreenEntered);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit: function exit() {
            return new Promise(function(resolve, reject) {
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = function onFullScreenExit() {
                    screenfull.off("fullscreenchange", onFullScreenExit);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on: function on(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off: function off(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function get() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function get() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function get() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
var $57f31ef0d5c81b91$var$playerMap = new WeakMap();
var $57f31ef0d5c81b91$var$readyMap = new WeakMap();
var $57f31ef0d5c81b91$var$screenfull = {};
var $57f31ef0d5c81b91$var$Player$1 = /*#__PURE__*/ function() {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ function Player(element) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $57f31ef0d5c81b91$var$_classCallCheck(this, Player);
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn("A jQuery object with multiple elements was passed, using the first element.");
            element = element[0];
        } // Find an element by ID
        if (typeof document !== "undefined" && typeof element === "string") element = document.getElementById(element);
         // Not an element!
        if (!$57f31ef0d5c81b91$var$isDomElement(element)) throw new TypeError("You must pass either a valid element or a valid id.");
         // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== "IFRAME") {
            var iframe = element.querySelector("iframe");
            if (iframe) element = iframe;
        } // iframe url is not a Vimeo url
        if (element.nodeName === "IFRAME" && !$57f31ef0d5c81b91$var$isVimeoUrl(element.getAttribute("src") || "")) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
         // If there is already a player object in the map, return that
        if ($57f31ef0d5c81b91$var$playerMap.has(element)) return $57f31ef0d5c81b91$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = "*";
        var readyPromise = new $57f31ef0d5c81b91$var$npo_src(function(resolve, reject) {
            _this._onMessage = function(event) {
                if (!$57f31ef0d5c81b91$var$isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) return;
                if (_this.origin === "*") _this.origin = event.origin;
                var data = $57f31ef0d5c81b91$var$parseMessageData(event.data);
                var isError = data && data.event === "error";
                var isReadyError = isError && data.data && data.data.method === "ready";
                if (isReadyError) {
                    var error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                var isReadyEvent = data && data.event === "ready";
                var isPingResponse = data && data.method === "ping";
                if (isReadyEvent || isPingResponse) {
                    _this.element.setAttribute("data-ready", "true");
                    resolve();
                    return;
                }
                $57f31ef0d5c81b91$var$processData(_this, data);
            };
            _this._window.addEventListener("message", _this._onMessage);
            if (_this.element.nodeName !== "IFRAME") {
                var params = $57f31ef0d5c81b91$var$getOEmbedParameters(element, options);
                var url = $57f31ef0d5c81b91$var$getVimeoUrl(params);
                $57f31ef0d5c81b91$var$getOEmbedData(url, params, element).then(function(data) {
                    var iframe = $57f31ef0d5c81b91$var$createEmbed(data, element); // Overwrite element with the new iframe,
                    // but store reference to the original element
                    _this.element = iframe;
                    _this._originalElement = element;
                    $57f31ef0d5c81b91$var$swapCallbacks(element, iframe);
                    $57f31ef0d5c81b91$var$playerMap.set(_this.element, _this);
                    return data;
                }).catch(reject);
            }
        }); // Store a copy of this Player in the map
        $57f31ef0d5c81b91$var$readyMap.set(this, readyPromise);
        $57f31ef0d5c81b91$var$playerMap.set(this.element, this); // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === "IFRAME") $57f31ef0d5c81b91$var$postMessage(this, "ping");
        if ($57f31ef0d5c81b91$var$screenfull.isEnabled) {
            var exitFullscreen = function exitFullscreen() {
                return $57f31ef0d5c81b91$var$screenfull.exit();
            };
            this.fullscreenchangeHandler = function() {
                if ($57f31ef0d5c81b91$var$screenfull.isFullscreen) $57f31ef0d5c81b91$var$storeCallback(_this, "event:exitFullscreen", exitFullscreen);
                else $57f31ef0d5c81b91$var$removeCallback(_this, "event:exitFullscreen", exitFullscreen);
                 // eslint-disable-next-line
                _this.ready().then(function() {
                    $57f31ef0d5c81b91$var$postMessage(_this, "fullscreenchange", $57f31ef0d5c81b91$var$screenfull.isFullscreen);
                });
            };
            $57f31ef0d5c81b91$var$screenfull.on("fullscreenchange", this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */ $57f31ef0d5c81b91$var$_createClass(Player, [
        {
            key: "callMethod",
            value: function callMethod(name) {
                var _this2 = this;
                var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return new $57f31ef0d5c81b91$var$npo_src(function(resolve, reject) {
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this2.ready().then(function() {
                        $57f31ef0d5c81b91$var$storeCallback(_this2, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $57f31ef0d5c81b91$var$postMessage(_this2, name, args);
                    }).catch(reject);
                });
            }
        },
        {
            key: "get",
            value: function get(name) {
                var _this3 = this;
                return new $57f31ef0d5c81b91$var$npo_src(function(resolve, reject) {
                    name = $57f31ef0d5c81b91$var$getMethodName(name, "get"); // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this3.ready().then(function() {
                        $57f31ef0d5c81b91$var$storeCallback(_this3, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $57f31ef0d5c81b91$var$postMessage(_this3, name);
                    }).catch(reject);
                });
            }
        },
        {
            key: "set",
            value: function set(name, value) {
                var _this4 = this;
                return new $57f31ef0d5c81b91$var$npo_src(function(resolve, reject) {
                    name = $57f31ef0d5c81b91$var$getMethodName(name, "set");
                    if (value === undefined || value === null) throw new TypeError("There must be a value to set.");
                     // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this4.ready().then(function() {
                        $57f31ef0d5c81b91$var$storeCallback(_this4, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $57f31ef0d5c81b91$var$postMessage(_this4, name, value);
                    }).catch(reject);
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (!callback) throw new TypeError("You must pass a callback function.");
                if (typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var callbacks = $57f31ef0d5c81b91$var$getCallbacks(this, "event:".concat(eventName));
                if (callbacks.length === 0) this.callMethod("addEventListener", eventName).catch(function() {
                // will trigger the error callback if they are listening.
                });
                $57f31ef0d5c81b91$var$storeCallback(this, "event:".concat(eventName), callback);
            }
        },
        {
            key: "off",
            value: function off(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (callback && typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var lastCallback = $57f31ef0d5c81b91$var$removeCallback(this, "event:".concat(eventName), callback); // If there are no callbacks left, remove the listener
                if (lastCallback) this.callMethod("removeEventListener", eventName).catch(function(e) {
                // will trigger the error callback if they are listening.
                });
            }
        },
        {
            key: "loadVideo",
            value: function loadVideo(options) {
                return this.callMethod("loadVideo", options);
            }
        },
        {
            key: "ready",
            value: function ready() {
                var readyPromise = $57f31ef0d5c81b91$var$readyMap.get(this) || new $57f31ef0d5c81b91$var$npo_src(function(resolve, reject) {
                    reject(new Error("Unknown player. Probably unloaded."));
                });
                return $57f31ef0d5c81b91$var$npo_src.resolve(readyPromise);
            }
        },
        {
            key: "addCuePoint",
            value: function addCuePoint(time) {
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.callMethod("addCuePoint", {
                    time: time,
                    data: data
                });
            }
        },
        {
            key: "removeCuePoint",
            value: function removeCuePoint(id) {
                return this.callMethod("removeCuePoint", id);
            }
        },
        {
            key: "enableTextTrack",
            value: function enableTextTrack(language, kind) {
                if (!language) throw new TypeError("You must pass a language.");
                return this.callMethod("enableTextTrack", {
                    language: language,
                    kind: kind
                });
            }
        },
        {
            key: "disableTextTrack",
            value: function disableTextTrack() {
                return this.callMethod("disableTextTrack");
            }
        },
        {
            key: "pause",
            value: function pause() {
                return this.callMethod("pause");
            }
        },
        {
            key: "play",
            value: function play() {
                return this.callMethod("play");
            }
        },
        {
            key: "requestFullscreen",
            value: function requestFullscreen() {
                if ($57f31ef0d5c81b91$var$screenfull.isEnabled) return $57f31ef0d5c81b91$var$screenfull.request(this.element);
                return this.callMethod("requestFullscreen");
            }
        },
        {
            key: "exitFullscreen",
            value: function exitFullscreen() {
                if ($57f31ef0d5c81b91$var$screenfull.isEnabled) return $57f31ef0d5c81b91$var$screenfull.exit();
                return this.callMethod("exitFullscreen");
            }
        },
        {
            key: "getFullscreen",
            value: function getFullscreen() {
                if ($57f31ef0d5c81b91$var$screenfull.isEnabled) return $57f31ef0d5c81b91$var$npo_src.resolve($57f31ef0d5c81b91$var$screenfull.isFullscreen);
                return this.get("fullscreen");
            }
        },
        {
            key: "requestPictureInPicture",
            value: function requestPictureInPicture() {
                return this.callMethod("requestPictureInPicture");
            }
        },
        {
            key: "exitPictureInPicture",
            value: function exitPictureInPicture() {
                return this.callMethod("exitPictureInPicture");
            }
        },
        {
            key: "getPictureInPicture",
            value: function getPictureInPicture() {
                return this.get("pictureInPicture");
            }
        },
        {
            key: "unload",
            value: function unload() {
                return this.callMethod("unload");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this5 = this;
                return new $57f31ef0d5c81b91$var$npo_src(function(resolve) {
                    $57f31ef0d5c81b91$var$readyMap.delete(_this5);
                    $57f31ef0d5c81b91$var$playerMap.delete(_this5.element);
                    if (_this5._originalElement) {
                        $57f31ef0d5c81b91$var$playerMap.delete(_this5._originalElement);
                        _this5._originalElement.removeAttribute("data-vimeo-initialized");
                    }
                    if (_this5.element && _this5.element.nodeName === "IFRAME" && _this5.element.parentNode) {
                        // If we've added an additional wrapper div, remove that from the DOM.
                        // If not, just remove the iframe element.
                        if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
                        else _this5.element.parentNode.removeChild(_this5.element);
                    } // If the clip is private there is a case where the element stays the
                    // div element. Destroy should reset the div and remove the iframe child.
                    if (_this5.element && _this5.element.nodeName === "DIV" && _this5.element.parentNode) {
                        _this5.element.removeAttribute("data-vimeo-initialized");
                        var iframe = _this5.element.querySelector("iframe");
                        if (iframe && iframe.parentNode) {
                            // If we've added an additional wrapper div, remove that from the DOM.
                            // If not, just remove the iframe element.
                            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                            else iframe.parentNode.removeChild(iframe);
                        }
                    }
                    _this5._window.removeEventListener("message", _this5._onMessage);
                    if ($57f31ef0d5c81b91$var$screenfull.isEnabled) $57f31ef0d5c81b91$var$screenfull.off("fullscreenchange", _this5.fullscreenchangeHandler);
                    resolve();
                });
            }
        },
        {
            key: "getAutopause",
            value: function getAutopause() {
                return this.get("autopause");
            }
        },
        {
            key: "setAutopause",
            value: function setAutopause(autopause) {
                return this.set("autopause", autopause);
            }
        },
        {
            key: "getBuffered",
            value: function getBuffered() {
                return this.get("buffered");
            }
        },
        {
            key: "getCameraProps",
            value: function getCameraProps() {
                return this.get("cameraProps");
            }
        },
        {
            key: "setCameraProps",
            value: function setCameraProps(camera) {
                return this.set("cameraProps", camera);
            }
        },
        {
            key: "getChapters",
            value: function getChapters() {
                return this.get("chapters");
            }
        },
        {
            key: "getCurrentChapter",
            value: function getCurrentChapter() {
                return this.get("currentChapter");
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return this.get("color");
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                return this.set("color", color);
            }
        },
        {
            key: "getCuePoints",
            value: function getCuePoints() {
                return this.get("cuePoints");
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return this.get("currentTime");
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(currentTime) {
                return this.set("currentTime", currentTime);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.get("duration");
            }
        },
        {
            key: "getEnded",
            value: function getEnded() {
                return this.get("ended");
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                return this.get("loop");
            }
        },
        {
            key: "setLoop",
            value: function setLoop(loop) {
                return this.set("loop", loop);
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                return this.set("muted", muted);
            }
        },
        {
            key: "getMuted",
            value: function getMuted() {
                return this.get("muted");
            }
        },
        {
            key: "getPaused",
            value: function getPaused() {
                return this.get("paused");
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.get("playbackRate");
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(playbackRate) {
                return this.set("playbackRate", playbackRate);
            }
        },
        {
            key: "getPlayed",
            value: function getPlayed() {
                return this.get("played");
            }
        },
        {
            key: "getQualities",
            value: function getQualities() {
                return this.get("qualities");
            }
        },
        {
            key: "getQuality",
            value: function getQuality() {
                return this.get("quality");
            }
        },
        {
            key: "setQuality",
            value: function setQuality(quality) {
                return this.set("quality", quality);
            }
        },
        {
            key: "getSeekable",
            value: function getSeekable() {
                return this.get("seekable");
            }
        },
        {
            key: "getSeeking",
            value: function getSeeking() {
                return this.get("seeking");
            }
        },
        {
            key: "getTextTracks",
            value: function getTextTracks() {
                return this.get("textTracks");
            }
        },
        {
            key: "getVideoEmbedCode",
            value: function getVideoEmbedCode() {
                return this.get("videoEmbedCode");
            }
        },
        {
            key: "getVideoId",
            value: function getVideoId() {
                return this.get("videoId");
            }
        },
        {
            key: "getVideoTitle",
            value: function getVideoTitle() {
                return this.get("videoTitle");
            }
        },
        {
            key: "getVideoWidth",
            value: function getVideoWidth() {
                return this.get("videoWidth");
            }
        },
        {
            key: "getVideoHeight",
            value: function getVideoHeight() {
                return this.get("videoHeight");
            }
        },
        {
            key: "getVideoUrl",
            value: function getVideoUrl() {
                return this.get("videoUrl");
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.get("volume");
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                return this.set("volume", volume);
            }
        }
    ]);
    return Player;
}(); // Setup embed only if this is not a node environment
if (!$57f31ef0d5c81b91$var$isNode) {
    $57f31ef0d5c81b91$var$screenfull = $57f31ef0d5c81b91$var$initializeScreenfull();
    $57f31ef0d5c81b91$var$initializeEmbeds();
    $57f31ef0d5c81b91$var$resizeEmbeds();
    $57f31ef0d5c81b91$var$initAppendVideoMetadata();
}
class $57f31ef0d5c81b91$var$VimeoPlayer extends $57f31ef0d5c81b91$var$AbstractVideoPlayer {
    constructor(target, videoId, options = {}){
        super(target, videoId, options);
        this.state.set($57f31ef0d5c81b91$var$INITIALIZED);
    }
    createPlayer(videoId) {
        const { options: options, options: { playerOptions: playerOptions = {} } } = this;
        const vimeoOptions = videoId.indexOf("http") === 0 ? {
            url: videoId
        } : {
            id: +videoId
        };
        const player = new $57f31ef0d5c81b91$var$Player$1(this.target, $57f31ef0d5c81b91$var$assign(vimeoOptions, {
            controls: !options.hideControls,
            loop: options.loop,
            muted: options.mute
        }, playerOptions.vimeo || {}));
        player.on("play", this.onPlay);
        player.on("pause", this.onPause);
        player.on("ended", this.onEnded);
        player.ready().then(this.onPlayerReady, this.onError);
        if (!player.getMuted()) player.setVolume($57f31ef0d5c81b91$var$clamp(options.volume, 0, 1));
        return player;
    }
    playVideo() {
        this.player.play().catch(()=>{
            if (this.state.is($57f31ef0d5c81b91$var$PLAY_REQUEST_ABORTED)) this.state.set($57f31ef0d5c81b91$var$IDLE);
        });
    }
    pauseVideo() {
        this.player.pause();
    }
}
const $57f31ef0d5c81b91$var$YOUTUBE_API_SRC = "//www.youtube.com/player_api";
class $57f31ef0d5c81b91$var$YouTubeIframeAPILoader {
    load(callback) {
        if (window.YT && $57f31ef0d5c81b91$var$isFunction(window.YT.Player)) return callback();
        this.attachCallback(callback);
        if (this.shouldLoad()) $57f31ef0d5c81b91$var$create("script", {
            src: `${location.protocol}${$57f31ef0d5c81b91$var$YOUTUBE_API_SRC}`
        }, document.head);
    }
    shouldLoad() {
        return !$57f31ef0d5c81b91$var$queryAll(document, "script").some((script)=>script.src.replace(/^https?:/, "") === $57f31ef0d5c81b91$var$YOUTUBE_API_SRC);
    }
    attachCallback(callback) {
        let oldCallback;
        if (!$57f31ef0d5c81b91$var$isUndefined(window.onYouTubeIframeAPIReady)) oldCallback = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = ()=>{
            oldCallback && oldCallback();
            callback();
        };
    }
}
class $57f31ef0d5c81b91$var$YouTubePlayer extends $57f31ef0d5c81b91$var$AbstractVideoPlayer {
    constructor(target, videoId, options = {}){
        super(target, videoId, options);
        this.videoId = this.parseVideoId(videoId);
        if (this.videoId) {
            this.state.set($57f31ef0d5c81b91$var$INITIALIZING);
            new $57f31ef0d5c81b91$var$YouTubeIframeAPILoader().load(this.onAPIReady.bind(this));
        }
    }
    onAPIReady() {
        const { state: state } = this;
        const isPending = state.is($57f31ef0d5c81b91$var$PENDING_PLAY);
        state.set($57f31ef0d5c81b91$var$INITIALIZED);
        if (isPending) this.play();
    }
    createPlayer(videoId) {
        const { options: options, options: { playerOptions: playerOptions = {} } } = this;
        return new YT.Player(this.target, {
            videoId: videoId,
            host: options.host,
            playerVars: $57f31ef0d5c81b91$var$assign({
                controls: options.hideControls ? 0 : 1,
                iv_load_policy: 3,
                loop: options.loop ? 1 : 0,
                playlist: options.loop ? videoId : void 0,
                rel: 0,
                autoplay: 0,
                mute: options.mute ? 1 : 0
            }, playerOptions.youtube || {}),
            events: {
                onReady: this.onPlayerReady.bind(this),
                onStateChange: this.onPlayerStateChange.bind(this),
                onError: this.onError.bind(this)
            }
        });
    }
    onPlayerReady() {
        super.onPlayerReady();
        this.player.setVolume($57f31ef0d5c81b91$var$clamp(this.options.volume, 0, 1) * 100);
    }
    onPlayerStateChange(e) {
        const { PLAYING: PLAYING, PAUSED: PAUSED, ENDED: ENDED } = YT.PlayerState;
        switch(true){
            case e.data === PLAYING:
                this.onPlay();
                break;
            case e.data === PAUSED:
                this.onPause();
                break;
            case e.data === ENDED:
                this.onEnded();
                break;
        }
    }
    playVideo() {
        this.player.playVideo();
    }
    pauseVideo() {
        this.player.pauseVideo();
    }
    parseVideoId(id) {
        return id.indexOf("http") === 0 ? this.parseUrl(id) : id;
    }
    parseUrl(url) {
        const [, search] = url.split(/[#?]/);
        const query = $57f31ef0d5c81b91$var$find(search.split("&"), (query2)=>query2.indexOf("v=") === 0);
        return query && query.replace("v=", "");
    }
}
const $57f31ef0d5c81b91$var$I18N = {
    playVideo: "Play Video"
};
class $57f31ef0d5c81b91$var$PlayerUI {
    constructor(Splide2, slide){
        this.event = $57f31ef0d5c81b91$var$EventInterface();
        this.Splide = Splide2;
        this.slide = slide;
        this.container = $57f31ef0d5c81b91$var$child(this.slide, `.${$57f31ef0d5c81b91$var$CLASS_CONTAINER}`);
        this.parent = this.container || this.slide;
        this.init();
        this.create();
        this.show();
        this.listen();
    }
    init() {
        $57f31ef0d5c81b91$var$addClass(this.slide, `${$57f31ef0d5c81b91$var$CLASS_SLIDE}${$57f31ef0d5c81b91$var$MODIFIER_HAS_VIDEO}`);
        $57f31ef0d5c81b91$var$addClass(this.container, `${$57f31ef0d5c81b91$var$CLASS_CONTAINER}${$57f31ef0d5c81b91$var$MODIFIER_HAS_VIDEO}`);
    }
    create() {
        this.video = $57f31ef0d5c81b91$var$create("div", $57f31ef0d5c81b91$var$CLASS_VIDEO, this.parent);
        this.playButton = $57f31ef0d5c81b91$var$create("button", {
            class: $57f31ef0d5c81b91$var$CLASS_VIDEO_PLAY_BUTTON,
            type: "button",
            "aria-label": this.Splide.options.i18n.playVideo || $57f31ef0d5c81b91$var$I18N.playVideo
        }, this.video);
        this.wrapper = $57f31ef0d5c81b91$var$create("div", $57f31ef0d5c81b91$var$CLASS_VIDEO_WRAPPER, this.video);
        this.placeholder = $57f31ef0d5c81b91$var$create("div", null, this.wrapper);
    }
    listen() {
        this.parent.addEventListener("click", ()=>{
            this.event.emit("click");
        });
    }
    toggleButton(show) {
        $57f31ef0d5c81b91$var$display(this.playButton, show ? "" : "none");
    }
    toggleWrapper(show) {
        $57f31ef0d5c81b91$var$display(this.wrapper, show ? "" : "none");
    }
    getPlaceholder() {
        return this.placeholder;
    }
    hide() {
        this.toggleButton(false);
        this.toggleWrapper(true);
    }
    show() {
        if (!this.disabled) this.toggleButton(true);
        this.toggleWrapper(false);
    }
    disable(disabled) {
        this.disabled = disabled;
        if (disabled) this.toggleButton(false);
    }
    on(events, callback) {
        this.event.on(events, callback);
    }
    destroy() {
        $57f31ef0d5c81b91$var$removeClass(this.slide, `${$57f31ef0d5c81b91$var$CLASS_SLIDE}${$57f31ef0d5c81b91$var$MODIFIER_HAS_VIDEO}`);
        $57f31ef0d5c81b91$var$removeClass(this.container, `${$57f31ef0d5c81b91$var$CLASS_CONTAINER}${$57f31ef0d5c81b91$var$MODIFIER_HAS_VIDEO}`);
        $57f31ef0d5c81b91$var$remove(this.video);
        this.event.destroy();
    }
}
const $57f31ef0d5c81b91$var$VIDEO_PLAYER_MAP = [
    [
        $57f31ef0d5c81b91$var$YOUTUBE_DATA_ATTRIBUTE,
        $57f31ef0d5c81b91$var$YouTubePlayer
    ],
    [
        $57f31ef0d5c81b91$var$VIMEO_DATA_ATTRIBUTE,
        $57f31ef0d5c81b91$var$VimeoPlayer
    ],
    [
        $57f31ef0d5c81b91$var$HTML_VIDEO__DATA_ATTRIBUTE,
        $57f31ef0d5c81b91$var$HTMLVideoPlayer
    ]
];
class $57f31ef0d5c81b91$var$Player {
    constructor(Splide2, slide){
        this.Splide = Splide2;
        this.slide = slide;
        this.event = $57f31ef0d5c81b91$var$EventInterface(Splide2);
        this.options = $57f31ef0d5c81b91$var$merge($57f31ef0d5c81b91$var$merge({}, $57f31ef0d5c81b91$var$DEFAULTS), this.Splide.options.video);
        this.createPlayer(slide);
        if (this.player) this.listen();
    }
    createPlayer(slide) {
        $57f31ef0d5c81b91$var$VIDEO_PLAYER_MAP.forEach(([attr, Constructor])=>{
            const id = $57f31ef0d5c81b91$var$getAttribute(slide, attr);
            if (id) {
                this.ui = new $57f31ef0d5c81b91$var$PlayerUI(this.Splide, slide);
                this.player = new Constructor(this.ui.getPlaceholder(), id, this.options);
                this.ui.disable(this.options.disableOverlayUI);
            }
        });
    }
    listen() {
        const { player: player, event: event } = this;
        this.ui.on("click", this.onClick.bind(this));
        player.on("play", this.onPlay.bind(this));
        player.on("played", this.onPlayed.bind(this));
        player.on("pause", this.onPause.bind(this));
        player.on("paused", this.onPaused.bind(this));
        player.on("ended", this.onEnded.bind(this));
        player.on("error", this.onError.bind(this));
        event.on([
            $57f31ef0d5c81b91$var$EVENT_MOVE,
            $57f31ef0d5c81b91$var$EVENT_SCROLL
        ], this.pause.bind(this));
        event.on($57f31ef0d5c81b91$var$EVENT_VIDEO_CLICK, this.onVideoClick.bind(this));
        event.on($57f31ef0d5c81b91$var$EVENT_DRAG, ()=>{
            event.off($57f31ef0d5c81b91$var$EVENT_DRAGGING);
            event.on($57f31ef0d5c81b91$var$EVENT_DRAGGING, ()=>{
                this.pause();
                event.off($57f31ef0d5c81b91$var$EVENT_DRAGGING);
            });
        });
        if (this.options.autoplay) event.on([
            $57f31ef0d5c81b91$var$EVENT_MOUNTED,
            $57f31ef0d5c81b91$var$EVENT_MOVED,
            $57f31ef0d5c81b91$var$EVENT_SCROLLED
        ], this.onAutoplayRequested.bind(this));
    }
    onClick() {
        this.isPaused() ? this.play() : this.pause();
        this.event.emit($57f31ef0d5c81b91$var$EVENT_VIDEO_CLICK, this);
    }
    onVideoClick(player) {
        if (this !== player) this.pause();
    }
    onPlay() {
        this.ui.hide();
    }
    onPlayed() {
        this.ui.hide();
        this.togglePlaying(true);
        this.event.emit($57f31ef0d5c81b91$var$EVENT_VIDEO_PLAY, this);
    }
    onPause() {
        this.ui.show();
    }
    onPaused() {
        this.togglePlaying(false);
        this.event.emit($57f31ef0d5c81b91$var$EVENT_VIDEO_PAUSE, this);
    }
    onEnded() {
        this.togglePlaying(false);
        this.event.emit($57f31ef0d5c81b91$var$EVENT_VIDEO_ENDED, this);
    }
    onError() {
        $57f31ef0d5c81b91$var$addClass(this.slide, $57f31ef0d5c81b91$var$CLASS_ERROR);
        this.ui.show();
        this.event.emit($57f31ef0d5c81b91$var$EVENT_VIDEO_ERROR, this);
    }
    onAutoplayRequested() {
        const activeSlide = this.Splide.Components.Slides.getAt(this.Splide.index);
        if (activeSlide.slide === this.slide) this.play();
    }
    togglePlaying(add) {
        $57f31ef0d5c81b91$var$toggleClass(this.Splide.root, $57f31ef0d5c81b91$var$CLASS_PLAYING, add);
    }
    play() {
        if (this.player && !this.disabled) this.player.play();
    }
    pause() {
        if (this.player && !this.disabled) this.player.pause();
    }
    destroy() {
        if (this.player) {
            this.ui.destroy();
            this.player.destroy();
        }
        this.disable(false);
    }
    disable(disabled) {
        this.disabled = disabled;
        $57f31ef0d5c81b91$var$toggleClass(this.Splide.root, $57f31ef0d5c81b91$var$CLASS_VIDEO_DISABLED, disabled);
    }
    isPaused() {
        return this.player.isPaused();
    }
}
function $57f31ef0d5c81b91$export$ae01dedf5c052bb(Splide2, Components2) {
    const { on: on } = $57f31ef0d5c81b91$var$EventInterface(Splide2);
    const { Slides: Slides } = Components2;
    const players = {};
    function mount() {
        create();
        on("refresh", create);
    }
    function create() {
        Slides.forEach((Slide)=>{
            const { slide: slide } = Slide;
            if (!$57f31ef0d5c81b91$var$hasClass(slide, `${$57f31ef0d5c81b91$var$CLASS_SLIDE}${$57f31ef0d5c81b91$var$MODIFIER_HAS_VIDEO}`)) players[Slide.index] = new $57f31ef0d5c81b91$var$Player(Splide2, slide);
        });
        Slides.update();
    }
    function destroy() {
        $57f31ef0d5c81b91$var$forOwn(players, (player)=>{
            player.destroy();
        });
    }
    function play(index = Splide2.index) {
        const player = players[index];
        if (player) player.play();
    }
    function pause() {
        $57f31ef0d5c81b91$var$forOwn(players, (player)=>{
            player.pause();
        });
    }
    function disable(disabled) {
        $57f31ef0d5c81b91$var$forOwn(players, (player)=>{
            player.disable(disabled);
        });
    }
    return {
        mount: mount,
        destroy: destroy,
        play: play,
        pause: pause,
        disable: disable
    };
}

});

})();
//# sourceMappingURL=splide-extension-video.esm.js.map
